<template>
  <div>
    版权声明
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>